export default __webpack_public_path__ + "static/media/icon-close-alt.e0b07075.svg";